import React, { useEffect, useRef } from 'react';
interface TableWrapperProps {
  children: React.ReactNode;
  searchTerm: string;
}
export function TableWrapper({
  children,
  searchTerm
}: TableWrapperProps) {
  const tableRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!tableRef.current) return;
    const rows = tableRef.current.querySelectorAll('tbody tr');
    const normalizedSearch = searchTerm.toLowerCase().trim();
    rows.forEach(row => {
      const cells = row.querySelectorAll('td');
      let found = false;
      // Clear previous highlights
      cells.forEach(cell => {
        cell.classList.remove('bg-yellow-200', 'animate-pulse');
      });
      if (normalizedSearch === '') {
        row.classList.remove('hidden');
        return;
      }
      // Search and highlight
      cells.forEach(cell => {
        const cellText = cell.textContent?.toLowerCase() || '';
        if (cellText.includes(normalizedSearch)) {
          cell.classList.add('bg-yellow-200');
          found = true;
        }
      });
      // Show/hide row based on search
      if (found) {
        row.classList.remove('hidden');
      } else {
        row.classList.add('hidden');
      }
    });
  }, [searchTerm]);
  return <div ref={tableRef} className="overflow-x-auto rounded-lg shadow-lg" data-id="element-857">
      {children}
    </div>;
}